import React, { useMemo } from 'react';
import { any, filter, includes, pluck, propEq, reduce } from 'ramda';
import { ROLES } from '../lib/rights';
import { RoleActionEnum } from '../components/users/utils/roles';

const useUserFormFilterOptions = (rolesDisplayed, selectedTeam) => {
  const { isSuperAdmin, disabledTeams, disabledOffers, currentTeamIsDisabled } = useMemo(() => {
    const checkIfValid = (roleToCheck) => (role) => propEq(roleToCheck, 'roleValue', role) && !propEq(RoleActionEnum.DELETE, 'action', role);

    const isSuperAdmin = any(checkIfValid(ROLES.superAdmin), rolesDisplayed);
    const teamsAdmin = filter(checkIfValid(ROLES.admin), rolesDisplayed);
    const disabledTeams = pluck('teamId', teamsAdmin);
    const disabledOffers = reduce((acc, { teamId, offer }) => {
      if (!teamId || !offer) return acc;
      if (!acc[teamId]) {
        acc[teamId] = [offer];
      } else if (!includes(offer, acc[teamId])) {
        acc[teamId].push(offer);
      }
      return acc;
    }, {}, rolesDisplayed);
    const currentTeamIsDisabled = includes(selectedTeam, disabledTeams);

    return {
      isSuperAdmin, disabledTeams, disabledOffers, currentTeamIsDisabled
    };
  }, [rolesDisplayed, selectedTeam]);

  return {
    isSuperAdmin, disabledTeams, disabledOffers, currentTeamIsDisabled 
  };
};

export default useUserFormFilterOptions;